import { trackPageEvent } from 'utils/tracking';
import rollbar from 'utils/rollbar';

const loadAttribute = 'data-lazy-load-embed-id';
export const rootContainerAttribute = 'data-lazy-load-embed-root-container';
export const clickReceiverAttribute = 'data-lazy-load-embed-click-receiver';

export const generateLoadAttribute = (id) => `${loadAttribute}="${id}"`;

const getLazyLoadButtons = (element) => [...element.querySelectorAll(`button[${loadAttribute}]`)];

const createOriginalEmbedHTML = ({ tagName, attribs }) => {
  const tag = document.createElement(tagName);
  Object.entries(attribs).forEach(([name, value]) => {
    try {
      // Wrapping this in a try/catch in case `name` is an invalid attribute
      tag.setAttribute(name, value);
    } catch {
      rollbar.warning(`LazyLoadEmbed invalid attribute ${name} with value ${value}`);
    }
  });
  return tag;
};

const getRootContainer = (element) => {
  if (null !== element.getAttribute(rootContainerAttribute)) {
    return element;
  }
  return getRootContainer(element.parentElement);
};

const makeReplaceWithOriginalEmbed = (rootContainer, originalEmbed) => () => {
  const parentContainer = rootContainer.parentNode;
  parentContainer.insertBefore(createOriginalEmbedHTML(originalEmbed), rootContainer);
  parentContainer.removeChild(rootContainer);
};

export const setupLazyLoadEmbeds = (container, lazyLoadEmbeds, onEmbedStarted) => {
  const playButtons = getLazyLoadButtons(container);
  const tearDown = playButtons.reduce((tearDownFn, playButton) => {
    const rootContainer = getRootContainer(playButton);
    const id = playButton.getAttribute(loadAttribute);
    const originalEmbed = lazyLoadEmbeds[id];
    const replaceWithOriginalEmbed = makeReplaceWithOriginalEmbed(rootContainer, originalEmbed);
    const clickReceiver = rootContainer.querySelector(`*[${clickReceiverAttribute}]`);
    const boundOnEmbedStarted = () => onEmbedStarted({ url: originalEmbed.attribs.src });
    clickReceiver.addEventListener('click', replaceWithOriginalEmbed);
    clickReceiver.addEventListener('click', boundOnEmbedStarted);

    return () => {
      tearDownFn();
      if (clickReceiver) {
        clickReceiver.removeEventListener('click', replaceWithOriginalEmbed);
        clickReceiver.removeEventListener('click', boundOnEmbedStarted);
      }
    };
  }, () => {});
  return { tearDown };
};
